// extracted by mini-css-extract-plugin
export default {"icon":"editButton_icon__7sJK+"};